import React, { useState } from 'react'
import styled, { css } from 'styled-components'

import { useStoreCode } from '../hooks'
import { Text, InputField, Button } from './UI'

const SStoreCode = styled.div`
	background-color: ${p => p.theme.colors.dark};
	height: 100%;
	position: relative;
`

const SPanel = styled.div<{ active: boolean }>`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);

	padding: ${p => p.theme.padding};
	background-color: ${p => p.theme.colors.light};
	border-radius: ${p => p.theme.borderRadius};

	display: grid;
	grid-gap: ${p => p.theme.gridGap};
	transition: .3s;

	${p => !p.active && css`
		transform: translate(-50%, -45%);
		opacity: 0;
	`}
`

interface IState {
	inputfield: string,

}

export default function StoreCode() {
	const [state, set] = useState<IState>({
		inputfield: '',
	})
	const storeCode = useStoreCode()

	function enterHandler(): void {
		storeCode.checkCode(state.inputfield)
		set(p => ({ ...p, inputfield: '' }))
	}

	return (
		<SStoreCode>
			<SPanel active={!storeCode.state.loading}>
				<Text oneline dark subTitle bold>You have a store code?</Text>
				<InputField
					value={state.inputfield}
					onChange={v => set(p => ({ ...p, inputfield: v }))}
					placeholder='Code...'
					onKeyDown={e => { if (e.keyCode === 13) enterHandler() }}
				/>
				<Button onClick={() => enterHandler()}>Enter</Button>
			</SPanel>
		</SStoreCode>
	)
}
